import Badge from "./Badge";

/*
  Figma "Icon button": Style Gray (filled circle) | Plain × Size M (44) | S (32,
  with a 44px tap area). Always has a label (aria-label and tooltip). A count
  shows a small danger badge; aria-pressed turns it accent/tinted; `selected`
  colours the icon control/selected-label.
*/
const SIZES = {
  m: "size-[44px]",
  s: "size-8 before:absolute before:-inset-1.5",
};

const VARIANTS = {
  gray: "bg-fill-secondary",
  plain: "",
};

export const STATE_LAYER =
  "after:pointer-events-none after:absolute after:inset-0 after:rounded-[inherit] after:bg-label-primary after:opacity-0 after:transition-opacity hover:after:opacity-[var(--state-hover)] active:after:opacity-[var(--state-pressed)]";

const IconButton = ({ label, size = "s", variant = "gray", count, selected = false, children, className = "", ...rest }) => (
  <button
    type="button"
    aria-label={count ? `${label} (${count})` : label}
    title={label}
    className={`relative flex shrink-0 items-center justify-center rounded-full outline-none focus-visible:shadow-[0_0_0_2px_var(--color-focus-ring)] aria-pressed:bg-accent-tinted aria-pressed:text-accent-tinted-label aria-disabled:cursor-not-allowed aria-disabled:opacity-40 disabled:text-label-tertiary ${STATE_LAYER} ${SIZES[size]} ${VARIANTS[variant]} ${selected ? "text-control-selected-label" : "text-label-primary"} ${className}`}
    {...rest}
  >
    {children}
    {count ? (
      <Badge size="s" tone="danger" className="absolute -right-1 -top-0.5 min-w-[20px]">
        {count > 99 ? "99+" : count}
      </Badge>
    ) : null}
  </button>
);

export default IconButton;
